<template>
  <div id="natcon-payment-create" class="natcon-luxury-app">
    <!-- Overlay Loader -->
    <v-overlay
      :value="ProgressLoadingFlag"
      z-index="99999"
      class="luxury-overlay"
    >
      <div class="luxury-spinner-wrapper">
        <v-progress-circular
          indeterminate
          size="72"
          width="5"
          color="#ffd700"
        ></v-progress-circular>
        <div class="luxury-spinner-text">Processing Request...</div>
      </div>
    </v-overlay>

    <!-- HERO HEADER SECTION -->
    <div class="luxury-hero-section">
      <!-- Animated Background Layers -->
      <div class="mesh-gradient-bg"></div>
      <div class="aurora-lights"></div>
      <div class="animated-glow-orbs">
        <div class="orb orb-1"></div>
        <div class="orb orb-2"></div>
        <div class="orb orb-3"></div>
      </div>
      <div class="moving-light-rays"></div>
      <div class="glass-reflection-overlay"></div>
      <div class="soft-noise-overlay"></div>

      <!-- Luxury Floating Decorative Elements -->
      <div class="luxury-decorations">
        <div class="floating-element diamond d1"></div>
        <div class="floating-element ring r1"></div>
        <div class="floating-element circle c1"></div>
        <div class="floating-element cube cb1"></div>
        <div class="floating-element golden-particle p1"></div>
        <div class="floating-element golden-particle p2"></div>
        <div class="floating-element sparkle s1">✦</div>
        <div class="floating-element sparkle s2">✦</div>
        <div class="floating-element sparkle s3">★</div>
        <div class="floating-element line l1"></div>
        <div class="floating-element glow-wave w1"></div>
      </div>

      <!-- Hero Content Container -->
      <div class="hero-content-wrapper">
        <!-- Premium Glass Hero Card -->
        <div class="hero-glass-card">
          <!-- Floating Glassy Bubble Animations -->
          <div class="hero-bubbles">
            <div class="bubble bubble-1"></div>
            <div class="bubble bubble-2"></div>
            <div class="bubble bubble-3"></div>
            <div class="bubble bubble-4"></div>
            <div class="bubble bubble-5"></div>
            <div class="bubble bubble-6"></div>
          </div>

          <div class="hero-card-glow-border"></div>
          <div class="hero-card-shine-sweep"></div>

          <div class="hero-badge">
            <span class="badge-icon">👑</span>
            <span class="badge-text">OFFICIAL EVENT REGISTRATION</span>
          </div>

          <h1 class="hero-main-title" v-if="PageTitle">
            {{ PageTitle }}
          </h1>
          <h1 class="hero-main-title" v-else>
            NATCON <span class="text-gradient-sky">REGISTRATION</span>
          </h1>

          <p class="hero-subtitle">
            {{
              PageDescription ||
              "Experience the grandest annual conference & celebration. Reserve your spot today."
            }}
          </p>

          <!-- Information Glass Pills -->
          <div class="hero-pills-row">
            <div class="hero-pill">
              <i class="mdi mdi-calendar pill-icon"></i>
              <span
                >Year:
                <strong>{{ YearName || JciYearCode || "2026" }}</strong></span
              >
            </div>
            <div class="hero-pill">
              <i class="mdi mdi-ticket pill-icon"></i>
              <span
                >Passes:
                <strong>{{ Plans.length || 0 }} Available</strong></span
              >
            </div>
            <div class="hero-pill" v-if="Lom && Lom.LomName">
              <i class="mdi mdi-shield-check pill-icon"></i>
              <span
                >{{ Lom.LomName }}
                <small v-if="Lom.ZoneName">({{ Lom.ZoneName }})</small></span
              >
            </div>
            <div class="hero-pill live-status">
              <span class="status-dot"></span>
              <span>Registration Open</span>
            </div>
          </div>

          <!-- Hero Action Buttons -->
          <div class="hero-actions-row">
            <button
              class="glass-btn primary-glass-btn"
              @click.prevent="refreshPageData"
            >
              <i class="mdi mdi-refresh btn-icon"></i>
              <span>Refresh Data</span>
            </button>

            <button
              class="glass-btn secondary-glass-btn"
              @click.prevent="resetForm"
            >
              <i class="mdi mdi-eraser btn-icon"></i>
              <span>Clear Form</span>
            </button>

            <router-link
              to="/natcon/non-member-payment/create"
              v-if="NonMemberButtonFlag"
              class="non-member-link"
            >
              <button class="glass-btn emerald-glass-btn">
                <i class="mdi mdi-account-plus btn-icon"></i>
                <span>Non-Member Registration</span>
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- STATISTICS SECTION -->
    <div class="luxury-stats-bar">
      <div class="stats-container">
        <div class="stat-card">
          <div class="stat-icon-box gold">
            <i class="mdi mdi-trophy"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">
              {{ YearName || JciYearCode || "2026" }}
            </div>
            <div class="stat-label">Event Year</div>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-icon-box purple">
            <i class="mdi mdi-domain"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value text-truncate" style="max-width: 160px">
              {{ (Lom && Lom.LomName) || "JCI India" }}
            </div>
            <div class="stat-label">
              {{ Lom && Lom.ZoneName ? Lom.ZoneName : "Local Organization" }}
            </div>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-icon-box blue">
            <i class="mdi mdi-account-tie"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value text-truncate" style="max-width: 160px">
              {{
                (Presidentmember && Presidentmember.LomPresidentFullName) ||
                "LO President"
              }}
            </div>
            <div class="stat-label">LO President</div>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-icon-box emerald">
            <i class="mdi mdi-check-decagram"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">Official Pass</div>
            <div class="stat-label">NATCON Registration</div>
          </div>
        </div>
      </div>
    </div>

    <!-- MAIN BODY CONTAINER -->
    <div class="luxury-main-content">
      <div class="d-flex justify-content-center my-4" v-if="LoadingFlag">
        <v-progress-circular
          indeterminate
          color="primary"
          size="48"
        ></v-progress-circular>
      </div>

      <!-- Startup Loading Skeletons -->
      <v-container v-if="StartupLoadingFlag">
        <v-row wrap>
          <v-col cols="12" md="4" v-for="n in 6" :key="n">
            <div class="skeleton-glass-card">
              <v-skeleton-loader
                v-bind="attrs"
                type="article, actions"
                dark
              ></v-skeleton-loader>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <div class="content-container" v-else>
        <!-- EXECUTIVE LO & PRESIDENT CARD -->
        <div
          class="executive-pass-card mb-6"
          v-if="ExecutiveLomPresidentPassFlag"
        >
          <div class="pass-card-glass">
            <div class="pass-header">
              <div class="pass-brand">
                <i class="mdi mdi-shield pass-brand-icon"></i>
                <span>JCI NATCON EXECUTIVE PASS</span>
              </div>
              <div class="pass-badge">LO OFFICER DETAILS</div>
            </div>

            <div class="pass-body">
              <div class="pass-info-col">
                <div class="pass-label">Local Organization (LO)</div>
                <div class="pass-value-lg">
                  {{ (Lom && Lom.LomName) || "Loading LO Details..." }}
                </div>
                <div class="pass-sublabel" v-if="Lom && Lom.ZoneName">
                  {{ Lom.ZoneName }}
                </div>
              </div>

              <div class="pass-col president-col">
                <div class="pass-avatar-wrapper" v-if="Presidentmember">
                  <v-img
                    :src="Presidentmember.MemberImagePath"
                    :alt="Presidentmember.LomPresidentFullName"
                    lazy-src="/no-image-available.png"
                    class="president-avatar"
                    max-width="64"
                    max-height="64"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="warning"
                          size="24"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </div>
                <div class="president-details" v-if="Presidentmember">
                  <div class="pass-label">LO President</div>
                  <div class="pass-value">
                    {{ Presidentmember.LomPresidentFullName || "N/A" }}
                  </div>
                  <div
                    class="pass-sublabel"
                    v-if="Presidentmember.LomPresidentMembershipId"
                  >
                    ID: {{ Presidentmember.LomPresidentMembershipId }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <v-form
          ref="form2"
          v-model="valid1"
          lazy-validation
          class="luxury-vform"
        >
          <!-- REGISTRATION & MEMBER SELECTION SECTION -->
          <div class="glass-form-card mb-6">
            <div class="glass-card-header">
              <div class="header-icon-box">
                <i class="mdi mdi-account"></i>
              </div>
              <div class="header-text">
                <h3 class="glass-card-title">Registration Setup</h3>
                <p class="glass-card-subtitle">
                  Select registration type and participant details (* required)
                </p>
              </div>
            </div>

            <div class="glass-card-body">
              <v-row wrap>
                <!-- Register For Dropdown -->
                <v-col cols="12" md="4" lg="4">
                  <div class="luxury-field-group">
                    <label class="luxury-label">
                      <span class="req-star">*</span> Register For
                    </label>
                    <v-select
                      :reduce="(option) => option.value"
                      :items="RegistrationTypeIdOptions"
                      :rules="RegistrationTypeIdRules"
                      v-model="RegistrationTypeId"
                      required
                      outlined
                      dense
                      class="luxury-input"
                    ></v-select>
                  </div>
                </v-col>

                <!-- Member Selection Autocomplete -->
                <v-col cols="12" md="6" lg="5" v-if="RegistrationTypeId >= 2">
                  <div class="luxury-field-group">
                    <label class="luxury-label">
                      <span class="req-star">*</span> Select Member
                    </label>
                    <v-autocomplete
                      @change="getMemberDetails"
                      :reduce="(option) => option.value"
                      :loading="MemberIdOptionsLoading"
                      :items="MemberIdOptions"
                      :rules="MemberIdRules"
                      v-model="MemberId"
                      required
                      outlined
                      dense
                      clearable
                      class="luxury-input member-autocomplete"
                    >
                      <template v-slot:selection="{ item }">
                        <div class="member-select-item">
                          <img
                            width="32"
                            height="32"
                            :src="item.photo"
                            class="member-thumb"
                          />
                          <span class="member-text">{{ item.text }}</span>
                        </div>
                      </template>
                      <template v-slot:item="{ item }">
                        <div class="member-select-item">
                          <img
                            width="36"
                            height="36"
                            :src="item.photo"
                            class="member-thumb"
                          />
                          <span class="member-text">{{ item.text }}</span>
                        </div>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>

          <!-- SELECTED PARTICIPANT VIP IDENTITY CARD (Apple Wallet Style) -->
          <div
            class="vip-identity-section mb-6"
            v-if="selectedMember && selectedMember.MemberId > 0"
          >
            <div class="vip-card">
              <div class="vip-card-glow"></div>
              <div class="vip-card-shine"></div>

              <div class="vip-card-top">
                <div class="vip-badge-tag">
                  <i class="mdi mdi-star-circle"></i> VIP PARTICIPANT PASS
                </div>
                <div class="vip-chip-logo">JCI NATCON</div>
              </div>

              <div class="vip-card-main">
                <div class="vip-photo-frame">
                  <v-img
                    :src="selectedMember.MemberImagePath"
                    :alt="selectedMember.MemberName"
                    lazy-src="/no-image-available.png"
                    class="vip-photo"
                    max-width="100"
                    max-height="100"
                    v-if="selectedMember.MemberImagePath != ''"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="warning"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </div>

                <div class="vip-member-info">
                  <h2 class="vip-name">{{ selectedMember.MemberName }}</h2>
                  <div class="vip-id-pill">
                    <i class="mdi mdi-card-account-details"></i>
                    <span
                      >Membership ID: {{ selectedMember.MembershipId }}</span
                    >
                  </div>
                  <div class="vip-status-chip">
                    <span class="chip-dot"></span> Active Participant
                  </div>
                </div>
              </div>

              <!-- PARTICIPANT FORM INPUTS -->
              <div class="vip-form-grid">
                <v-row wrap>
                  <!-- Mobile Number -->
                  <v-col cols="12" sm="6" md="3">
                    <div class="luxury-field-group">
                      <label class="luxury-label">
                        <span class="req-star">*</span> Mobile Number
                      </label>
                      <v-text-field
                        v-model="selectedMember.MobileNo"
                        :rules="MobileNoRules"
                        :counter="10"
                        v-mask="'##########'"
                        type="number"
                        hint="10-digit mobile number"
                        dense
                        outlined
                        class="luxury-input"
                      ></v-text-field>
                    </div>
                  </v-col>

                  <!-- Email Id -->
                  <v-col cols="12" sm="6" md="3">
                    <div class="luxury-field-group">
                      <label class="luxury-label">
                        <span class="req-star">*</span> Email Id
                      </label>
                      <v-text-field
                        v-model="selectedMember.EmailId"
                        :rules="EmailIdRules"
                        type="email"
                        hint="Valid email address"
                        dense
                        outlined
                        class="luxury-input"
                      ></v-text-field>
                    </div>
                  </v-col>

                  <!-- Gender -->
                  <v-col cols="12" sm="6" md="3">
                    <div class="luxury-field-group">
                      <label class="luxury-label">
                        <span class="req-star">*</span> Gender
                      </label>
                      <v-select
                        :reduce="(option) => option.value"
                        v-model="selectedMember.Gender"
                        :items="GenderOptions"
                        :rules="GenderRules"
                        required
                        outlined
                        dense
                        class="luxury-input"
                      ></v-select>
                    </div>
                  </v-col>

                  <!-- Food Preference -->
                  <v-col cols="12" sm="6" md="3">
                    <div class="luxury-field-group">
                      <label class="luxury-label">
                        <span class="req-star">*</span> Food Preference
                      </label>
                      <v-select
                        :reduce="(option) => option.value"
                        v-model="selectedMember.FoodChoice"
                        :items="FoodPreferenceOptions"
                        :rules="FoodPreferenceRules"
                        required
                        outlined
                        dense
                        class="luxury-input"
                      ></v-select>
                    </div>
                  </v-col>

                  <!-- GST Bill Flag -->
                  <v-col cols="12" sm="6" md="3">
                    <div class="luxury-field-group">
                      <label class="luxury-label">
                        GST Bill <small>(optional)</small>
                      </label>
                      <v-select
                        :reduce="(option) => option.value"
                        v-model="selectedMember.GstNumberFlag"
                        :items="GstNumberFlagOptions"
                        :rules="GstNumberFlagRules"
                        required
                        outlined
                        dense
                        class="luxury-input"
                      ></v-select>
                    </div>
                  </v-col>

                  <!-- GST Number -->
                  <v-col
                    cols="12"
                    sm="6"
                    md="3"
                    v-if="selectedMember.GstNumberFlag == 1"
                  >
                    <div class="luxury-field-group">
                      <label class="luxury-label">
                        <span class="req-star">*</span> GST Number
                      </label>
                      <v-text-field
                        v-model="selectedMember.GstNumber"
                        :rules="GstNumberRules"
                        :counter="15"
                        v-mask="'##AAAAA####A#ZN'"
                        hint="Enter 15-digit GSTIN"
                        dense
                        outlined
                        class="luxury-input"
                      ></v-text-field>
                    </div>
                  </v-col>

                  <!-- Tshirt Size -->
                  <v-col cols="12" sm="6" md="3" v-if="AspacFlag">
                    <div class="luxury-field-group">
                      <label class="luxury-label">
                        <span class="req-star">*</span> T-Shirt Size
                      </label>
                      <v-select
                        :reduce="(option) => option.value"
                        v-model="TshirtSize"
                        :items="TshirtSizeOptions"
                        :rules="TshirtSizeRules"
                        required
                        outlined
                        dense
                        class="luxury-input"
                      ></v-select>
                    </div>
                  </v-col>

                  <!-- Passport Number -->
                  <v-col cols="12" sm="6" md="3" v-if="AspacFlag">
                    <div class="luxury-field-group">
                      <label class="luxury-label">
                        <span class="req-star">*</span> Passport Number
                      </label>
                      <v-text-field
                        v-model="PassportNumber"
                        :rules="PassportNumberRules"
                        hint="Enter valid passport number"
                        dense
                        outlined
                        class="luxury-input"
                      ></v-text-field>
                    </div>
                  </v-col>

                  <!-- Senator Number -->
                  <v-col cols="12" sm="6" md="3">
                    <div class="luxury-field-group">
                      <label class="luxury-label">
                        Senator Number <small>(optional)</small>
                      </label>
                      <v-text-field
                        v-model="SenatorNumber"
                        :rules="SenatorNumberRules"
                        hint="Applicable for Senator title holders"
                        dense
                        outlined
                        class="luxury-input"
                      ></v-text-field>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>

          <!-- EVENT PLAN DETAILS PREVIEW DIALOG -->
          <v-dialog
            v-model="PreviewPlanFlag"
            width="550"
            content-class="luxury-preview-modal"
          >
            <event-plan-details
              :Plan="PreviewPlanDetails"
              @hideDialog="hidePreviewPlanPopup($event)"
              v-if="PreviewPlanFlag"
            ></event-plan-details>
          </v-dialog>

          <!-- PREMIUM PLAN SECTION HEADER -->
          <div class="plans-section-header">
            <div class="section-badge">SELECT YOUR EVENT PASS</div>
            <h2 class="section-title">Available Registration Packages</h2>
            <p class="section-subtitle">
              Choose the plan that fits your conference experience
            </p>

            <!-- SINGLE GLOBAL EXISTING PLAN BANNER FOR UPGRADES -->
            <div
              class="global-existing-plan-banner"
              v-if="
                Plans &&
                Plans.length > 0 &&
                Plans[0].UpgradeFlag &&
                Plans[0].ExistingPlanName
              "
            >
              <i class="mdi mdi-arrow-up-circle-outline mr-1"></i>
              <span
                >Existing Plan:
                <strong>{{ Plans[0].ExistingPlanName }}</strong></span
              >
            </div>
          </div>

          <!-- PLANS GRID CONTAINER -->
          <v-row justify="center" class="plans-grid-row">
            <template v-for="(item, index) in Plans">
              <v-col
                :key="index"
                cols="12"
                sm="6"
                md="4"
                lg="4"
                class="plan-card-col"
              >
                <!-- RECOMMENDED PLAN CARD -->
                <div v-if="item.Recommended" class="h-100">
                  <div class="cards-box" v-if="item.PlanVisibleFlag">
                    <div
                      class="cards popular luxury-plan-card recommended-card"
                    >
                      <!-- 3D Folded Metallic Gold Ribbon -->
                      <div class="luxury-3d-ribbon">
                        <div class="ribbon-shine"></div>
                        <span>⭐ MOST POPULAR</span>
                      </div>

                      <!-- Continuous Diagonal Shimmer Light & Silvery Sheen -->
                      <div class="silvery-shine-sweep"></div>
                      <div class="card-shimmer-sweep"></div>
                      <div class="card-glow-aura"></div>

                      <div class="cards-title-bar">
                        <h3 class="cards-title gold-title">
                          {{ item.PlanName }}
                        </h3>

                        <!-- UPGRADE BANNER -->
                        <div v-if="item.UpgradeFlag" class="upgrade-info-card">
                          <div class="upgrade-badge-header">
                            <v-chip color="warning" small class="upgrade-pill">
                              <i class="mdi mdi-arrow-up-circle mr-1"></i> PLAN
                              UPGRADE
                            </v-chip>
                          </div>

                          <div class="upgrade-details-list">
                            <div
                              class="upgrade-detail-row"
                              v-if="
                                item.OriginalTotalAmountTxt ||
                                item.OriginalSubTotalTxt
                              "
                            >
                              <span class="detail-label">Original Price:</span>
                              <span class="detail-value highlight-gold">
                                {{
                                  item.OriginalTotalAmountTxt ||
                                  item.OriginalSubTotalTxt
                                }}
                              </span>
                            </div>
                            <div
                              class="upgrade-detail-row"
                              v-if="item.ExistingPlanAmountTxt"
                            >
                              <span class="detail-label">Paid Credit:</span>
                              <span class="detail-value highlight-emerald">
                                - {{ item.ExistingPlanAmountTxt }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="cards-price">
                        <div
                          v-if="item.UpgradeFlag"
                          class="upgrade-pending-txt mb-2"
                        >
                          Pending Payable Amount:
                        </div>
                        <h4 class="cards-price-amount">
                          {{ item.TotalAmountTxt || item.SubTotalTxt }}
                          <small class="cards-price-validity">per head</small>
                        </h4>

                        <div class="my-2">
                          <v-btn
                            color="warning"
                            outlined
                            rounded
                            small
                            class="show-details-btn"
                            @click.prevent="showPreviewPlanPopup(item)"
                          >
                            <i class="mdi mdi-eye-outline mr-1"></i> Show Plan
                            Details
                          </v-btn>
                        </div>
                      </div>

                      <div class="cards-total-box">
                        <div class="total-divider"></div>
                        <h1 class="cards-price-amount total-amount-display">
                          <small class="cards-price-validity"
                            >Total Amount</small
                          >
                          ₹ {{ formatCurrency(item.TotalAmount) }}
                        </h1>
                      </div>

                      <div class="cards-action mt-4">
                        <button
                          class="cards-action-button gold-action-btn"
                          :disabled="!valid1"
                          @click.prevent="confirmAlert(item)"
                        >
                          <span class="btn-text">{{
                            item.ButtonText || "Pay now"
                          }}</span>
                          <i class="mdi mdi-arrow-right btn-arrow"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- STANDARD OR UPGRADE PLAN CARD -->
                <div v-else class="h-100">
                  <div class="cards-box" v-if="item.PlanVisibleFlag">
                    <div
                      class="cards luxury-plan-card"
                      :class="
                        item.UpgradeFlag
                          ? 'emerald-upgrade-card'
                          : 'standard-card'
                      "
                    >
                      <div class="silvery-shine-sweep"></div>
                      <div class="card-shimmer-sweep"></div>
                      <div class="card-glow-aura"></div>

                      <div class="cards-title-bar">
                        <h3
                          class="cards-title"
                          :class="item.UpgradeFlag ? 'emerald-title' : ''"
                        >
                          {{ item.PlanName }}
                        </h3>

                        <!-- UPGRADE BANNER FOR NON-RECOMMENDED -->
                        <div v-if="item.UpgradeFlag" class="upgrade-info-card">
                          <div class="upgrade-badge-header">
                            <v-chip color="success" small class="upgrade-pill">
                              <i class="mdi mdi-arrow-up-bold-circle mr-1"></i>
                              PLAN UPGRADE
                            </v-chip>
                          </div>

                          <div class="upgrade-details-list">
                            <div
                              class="upgrade-detail-row"
                              v-if="
                                item.OriginalTotalAmountTxt ||
                                item.OriginalSubTotalTxt
                              "
                            >
                              <span class="detail-label">Original Price:</span>
                              <span class="detail-value highlight-gold">
                                {{
                                  item.OriginalTotalAmountTxt ||
                                  item.OriginalSubTotalTxt
                                }}
                              </span>
                            </div>
                            <div
                              class="upgrade-detail-row"
                              v-if="item.ExistingPlanAmountTxt"
                            >
                              <span class="detail-label">Paid Credit:</span>
                              <span class="detail-value highlight-emerald">
                                - {{ item.ExistingPlanAmountTxt }}
                              </span>
                            </div>
                          </div>
                        </div>

                        <h4 class="cards-subtitle" v-if="item.PlanDescription">
                          {{ item.PlanDescription }}
                        </h4>
                      </div>

                      <div class="cards-price">
                        <h4 class="cards-price-amount">
                          {{ item.SubTotalTxt }}
                          <br />
                          <span class="cards-price-gst"
                            >+ {{ item.TaxAmountTxt }} gst</span
                          >
                          <small class="cards-price-validity">per head</small>
                        </h4>

                        <div class="my-2">
                          <v-btn
                            :color="item.UpgradeFlag ? 'success' : 'primary'"
                            outlined
                            rounded
                            small
                            class="show-details-btn"
                            @click.prevent="showPreviewPlanPopup(item)"
                          >
                            <i class="mdi mdi-eye-outline mr-1"></i> Show Plan
                            Details
                          </v-btn>
                        </div>
                      </div>

                      <div class="cards-total-box">
                        <div class="total-divider"></div>
                        <h1 class="cards-price-amount total-amount-display">
                          <small class="cards-price-validity"
                            >Total Amount</small
                          >
                          ₹ {{ formatCurrency(item.TotalAmount) }}
                        </h1>
                      </div>

                      <div class="cards-action mt-4">
                        <button
                          class="cards-action-button"
                          :class="
                            item.UpgradeFlag
                              ? 'emerald-action-btn'
                              : 'standard-action-btn'
                          "
                          :disabled="!valid1"
                          @click.prevent="confirmAlert(item)"
                          :loading="SubmitFlag"
                        >
                          <span class="btn-text">{{
                            item.ButtonText ||
                            (item.UpgradeFlag ? "⬆ Upgrade Now" : "Pay now")
                          }}</span>
                          <i class="mdi mdi-arrow-right btn-arrow"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </template>
          </v-row>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import EventPlanDetails from "@/view/pages/erp/events/natcon/EventPlanDetails.vue";

export default {
  mixins: [common],
  components: {
    EventPlanDetails,
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      StartupLoadingFlag: false,
      ProgressLoadingFlag: false,
      SubmitFlag: false,
      SearchFlag: false,
      rows: [],

      NonMemberButtonFlag: false,
      AspacFlag: false,

      PreviewPlanFlag: false,
      PreviewPlanDetails: {},

      tableColumns1: [],
      tableColumns2: [
        { text: "Date", value: "PaidDateTxt", width: "13%" },
        { text: "Description", value: "Description", width: "35%" },
        { text: "Late Fee", value: "FineAmountTxt", width: "13%" },
        { text: "To be paid", value: "FineNotPaid", width: "13%" },
        { text: "No of members", value: "Qty", width: "13%" },
        { text: "Sub Total", value: "SubTotal", width: "13%" },
      ],

      selected: [],
      search: "",

      RegistrationTypeId: "",
      RegistrationTypeIdRules: [(v) => !!v || "Registor for is required"],
      RegistrationTypeIdOptions: [
        { value: "", text: "--Select Type--" },
        { value: 1, text: "Chief delegate" },
        // { value: 2, text: "Alternate chief delegate" },
        // { value: 3, text: "Member" },
      ],

      Gender: "",
      GenderRules: [(v) => !!v || "Gender is required"],
      GenderOptions: [
        { value: "", text: "--Select--" },
        { value: 1, text: "Male" },
        { value: 2, text: "Female" },
        { value: 3, text: "Other" },
      ],

      FoodPreference: "",
      FoodPreferenceRules: [(v) => !!v || "Food preference is required"],
      FoodPreferenceOptions: [
        { value: "", text: "--Select--" },
        { value: 1, text: "Veg" },
        { value: 2, text: "Non Veg" },
      ],

      Lom: {},

      Presidentmember: {},
      Plans: [],

      selectedPlan: {},
      selectedMember: {},

      MemberIdRules: [(v) => !!v || "Member is required"],
      MemberId: "",
      MemberIdOptions: [],
      MemberIdOptionsLoading: false,

      CheckoutTableHeaders: [],

      tab: null,
      TabDisable1: false,
      TabDisable2: false,

      TotalAmount: 0,
      Contribution: [],

      TotalAmount1: 0,
      TotalAmount2: 0,

      Member: {},
      Order: {},
      MemberImageFlag: false,

      PenaltySubscription: [],

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      OrderType: 1,

      JciYearCodeRules: [(v) => !!v || "Year is required"],
      JciYearCodeOptions: [],
      JciYearCodeOptionsLoading: false,

      MobileNoRules: [(v) => !!v || "Mobile No is required"],

      EmailIdRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],

      QtyRules: [
        (v) => Number.isInteger(Number(v)) || "Nos is invalid",
        (v) => v >= 0 || "Number must be greater than zero",
      ],

      GstNumberFlag: 2,
      GstNumberFlagRules: [],
      GstNumberFlagOptions: [
        { value: "", text: "--Select--" },
        { value: 1, text: "Yes" },
        { value: 2, text: "No" },
      ],

      GstNumber: "",
      GstNumberRules: [(v) => !!v || "GST number is required"],

      TshirtSize: "",
      TshirtSizeRules: [(v) => !!v || "T-Shirt size is required"],
      TshirtSizeOptions: [
        { value: "", text: "--Select--" },
        { value: "S", text: "S" },
        { value: "M", text: "M" },
        { value: "L", text: "L" },
        { value: "XL", text: "XL" },
        { value: "XXL", text: "XXL" },
        { value: "3XL", text: "3XL" },
        { value: "4XL", text: "4XL" },
        { value: "5XL", text: "5XL" },
      ],

      PassportNumber: "",
      PassportNumberRules: [(v) => !!v || "Passport number is required"],

      SenatorNumber: "",
      SenatorNumberRules: [],

      LomCode: "",
      MemberTypeId: 1,

      EventId: "",
      EventTypeId: 1,

      Order: {
        back_url: "",
        customer_name: "",
        customer_email_id: "",
        customer_mobile_no: "",
        rzp_action: "#",
        rzp_account_id: "",
        rzp_key: "bdgzbd",
        rzp_amount: "",
        rzp_order_id: "",
        rzp_buttontext: "Pay now",
        rzp_name: "JCI India Foundation",
        rzp_description: "",
        rzp_image: "",
        rzp_color: "#0096d5",
      },

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {},
  mounted() {
    /*
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Vuetify", route: "alerts" },
      { title: "Form Inputs & Control", route: "autocompletes" },
      { title: "Fileinptus" },
    ]);
    */
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = CurrentJciYearId;

        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? "" : LomId;
        this.LomCode = LomId;

        var ZoneCode = this.$session.get("ZoneId");
        ZoneCode = ZoneCode == (null || undefined) ? "" : ZoneCode;
        console.log("ZoneCode=" + ZoneCode);
        this.ZoneCode = ZoneCode;

        this.pageData();
      }
    },
    JciYearCodeOptions: function () {
      console.log("watch JciYearCodeOptions");
      this.LoadingFlag = false;
      this.JciYearCodeOptionsLoading = false;
    },
    MemberIdOptions: function () {
      this.MemberIdOptionsLoading = false;
    },
    MemberId: function () {
      console.log("watch MemberId");
      if (this.RegistrationTypeId >= 2) {
        this.getMemberDetails();
      }
    },
    RegistrationTypeId: function () {
      console.log("watch RegistrationTypeId");
      this.selectedMember = {};
      var RegistrationTypeId = this.RegistrationTypeId;
      console.log("RegistrationTypeId=" + RegistrationTypeId);
      if (RegistrationTypeId != "") {
        if (RegistrationTypeId == 1) {
          var Presidentmember = this.Presidentmember;
          console.log("Presidentmember=" + JSON.stringify(Presidentmember));
          if (Presidentmember && Presidentmember.LomPresidentMemberId) {
            this.selectedMember = {
              MemberId: Presidentmember.LomPresidentMemberId,
              MemberName: Presidentmember.LomPresidentFullName,
              MembershipId: Presidentmember.LomPresidentMembershipId,
              MobileNo: Presidentmember.LomPresidentMobileNo,
              EmailId: Presidentmember.LomPresidentEmailid,
              Gender: Presidentmember.LomPresidentGender,
              FoodChoice: Presidentmember.LomPresidentFoodChoice,
              MemberImagePath: Presidentmember.MemberImagePath,
            };
            this.getEventsDetails();
          }
        } else if (RegistrationTypeId >= 2) {
          this.getMemberDetails();
        } else {
        }
      }
    },
  },
  methods: {
    formatCurrency(amount) {
      if (amount === null || amount === undefined || amount === "") return "0.00";
      var num = parseFloat(amount);
      if (isNaN(num)) return "0.00";
      return num.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var id = this.$route.query.id;
      console.log({ id });
      this.EventId = id;
      var url1 = "api/jci-program/show";
      var condition1 = {
        UserInterface: 1,
        Program: id,
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      this.RegistrationTypeId = 1;
      this.getPresidentMemberDetails();
      this.getMemberIdOptions();
    },
    showPreviewPlanPopup(tr) {
      this.PreviewPlanDetails = tr;
      this.PreviewPlanFlag = true;
    },
    hidePreviewPlanPopup() {
      this.PreviewPlanDetails = {};
      this.PreviewPlanFlag = false;
    },
    // code 1
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    addRecord() {
      console.log("addRecord called");
      var url = "/staff/list";
      var params = {};
      this.pageRedirect(params, url);
    },
    resetForm() {
      this.$refs.form2.reset();
      this.selectedMember = {};
      this.selectedPlan = {};
      // this.refreshPageData();
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    getMemberIdOptions() {
      console.log("getMemberIdOptions called");
      this.MemberIdOptionsLoading = true;
      var selectbox1_source = "MemberId";
      var selectbox1_destination = "MemberIdOptions";
      var selectbox1_url = "api/members/options";
      var selectbox1_conditions_array = {
        UserInterface: 2,
        LomCode: this.LomCode,
        MemberType: this.MemberTypeId,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getMemberDetails() {
      console.log("getMemberDetails called");
      this.selectedMember = {};
      var temp_code = this.MemberId;
      console.log("temp_code=" + temp_code);
      var idx = this.MemberIdOptions.map((e) => e.value).indexOf(temp_code);
      console.log("idx=" + idx);
      if (idx >= 0) {
        var member = this.MemberIdOptions[idx];
        console.log("member=" + JSON.stringify(member));
        this.selectedMember = {
          MemberId: member.value,
          MemberName: member.member_name,
          MembershipId: member.membership_id,
          MobileNo: member.mobile_no,
          EmailId: member.email_id,
          Gender: member.gender,
          FoodChoice: member.food_choice,
          MemberImagePath: member.photo,
        };
        this.getEventsDetails();
      }
    },
    getPresidentMemberDetails() {
      console.log("getPresidentMemberDetails is called");

      var LomId = this.LomCode;
      console.log("LomId=" + LomId);

      if (LomId != "") {
        this.SubmitFlag = true;
        this.StartupLoadingFlag = true;
        this.Presidentmember = {};

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom/show";
        var upload = {
          UserInterface: 2,
          Lom: LomId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SubmitFlag = false;
            thisIns.StartupLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.Lom = records;
              thisIns.Presidentmember = records.President;
              if (
                thisIns.RegistrationTypeId == 1 &&
                records.President &&
                records.President.LomPresidentMemberId
              ) {
                var Presidentmember = records.President;
                thisIns.selectedMember = {
                  MemberId: Presidentmember.LomPresidentMemberId,
                  MemberName: Presidentmember.LomPresidentFullName,
                  MembershipId: Presidentmember.LomPresidentMembershipId,
                  MobileNo: Presidentmember.LomPresidentMobileNo,
                  EmailId: Presidentmember.LomPresidentEmailid,
                  Gender: Presidentmember.LomPresidentGender,
                  FoodChoice: Presidentmember.LomPresidentFoodChoice,
                  MemberImagePath: Presidentmember.MemberImagePath,
                };
                thisIns.getEventsDetails();
              }
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
            thisIns.StartupLoadingFlag = false;
          });
      } else {
        var message = "";
        if (LomId == "") {
          message += "Your session is expired. Kindly login again. ";
        }
        this.toast("error", message);
      }
    },
    getEventsDetails() {
      console.log("getEventsDetails is called");
      console.log("selectedMember=" + JSON.stringify(this.selectedMember));
      console.log("this.MemberId=" + this.MemberId);

      var EventId = this.EventId;
      console.log("EventId=" + EventId);

      if (EventId != "") {
        this.SubmitFlag = true;
        this.StartupLoadingFlag = true;

        this.Plans = [];

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/jci-program/plan/lists";
        var memberId =
          this.selectedMember && this.selectedMember.MemberId
            ? this.selectedMember.MemberId
            : this.MemberId || "";
        console.log("memberId=" + memberId);
        var upload = {
          UserInterface: 2,
          Program: EventId,
          ProgramType: this.EventTypeId,
          Member: memberId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SubmitFlag = false;
            thisIns.StartupLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.Plans = records.TableData;
              // thisIns.toast("success", output);
              // thisIns.resetForm();
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
            thisIns.StartupLoadingFlag = false;
          });
      } else {
        var message = "";
        if (EventId == "") {
          message += "Event id should not be empty";
        }
        this.toast("error", message);
      }
    },
    confirmAlert(selectedPlan) {
      var validate1 = this.$refs.form2.validate();
      this.selectedPlan = selectedPlan;
      var selectedMember = this.selectedMember;
      console.log(
        "validate1=" +
          validate1 +
          ", selectedPlan=" +
          JSON.stringify(selectedPlan) +
          ", selectedMember=" +
          JSON.stringify(selectedMember)
      );

      var MemberId = selectedMember.MemberId;
      MemberId = MemberId == (null || undefined) ? "" : MemberId;
      console.log("MemberId=" + MemberId);

      var EventPlanId = selectedPlan.EventPlanId;
      EventPlanId = EventPlanId == (null || undefined) ? "" : EventPlanId;
      console.log("EventPlanId=" + EventPlanId);

      if (validate1 && MemberId != "" && EventPlanId != "") {
        var htmlTxt = "";
        // htmlTxt += "<b>Please verify all the information before proceeding</b>";
        htmlTxt += "<b>Selected member details</b>";
        htmlTxt += "<br/>Member Name <b>" + selectedMember.MemberName + "</b>";
        htmlTxt += "<br/>Mobile no. <b>" + selectedMember.MobileNo + "</b>";
        htmlTxt += "<br/>Email id <b>" + selectedMember.EmailId + "</b>";
        htmlTxt +=
          "<br/><img width='100' height='100' src='" +
          selectedMember.MemberImagePath +
          "' />";
        htmlTxt += "<br/><b>Selected plan details</b>";
        htmlTxt += "<br/>Plan name <b>" + selectedPlan.PlanName + "</b>";
        htmlTxt +=
          "<br/>Total amount <b>" + selectedPlan.TotalAmountTxt + "</b>";
        htmlTxt += "<br/><br/>Do you want to continue?";
        Swal.fire({
          title: "Please verify all the information before proceeding",
          text: "",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: `Continue`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
            // this.makePayment();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        if (MemberId == "") {
          message += "Kindly select member. ";
        }
        if (EventPlanId == "") {
          message += "Kindly select plan. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
    submitForm() {
      console.log("submitForm is called");

      var validate1 = this.$refs.form2.validate();
      var selectedPlan = this.selectedPlan;
      var selectedMember = this.selectedMember;
      console.log(
        "validate1=" +
          validate1 +
          ", selectedPlan=" +
          JSON.stringify(selectedPlan) +
          ", selectedMember=" +
          JSON.stringify(selectedMember)
      );

      var MemberId = selectedMember.MemberId;
      MemberId = MemberId == (null || undefined) ? "" : MemberId;
      console.log("MemberId=" + MemberId);

      var EventPlanId = selectedPlan.EventPlanId;
      EventPlanId = EventPlanId == (null || undefined) ? "" : EventPlanId;
      console.log("EventPlanId=" + EventPlanId);

      var participants = [];
      participants.push(selectedMember);

      var TotalCount = participants.length;
      console.log("TotalCount=" + TotalCount);

      var EventTotalAmount = selectedPlan.TotalAmount;
      console.log("EventTotalAmount=" + EventTotalAmount);

      var TotalAmount = parseFloat(TotalCount) * parseFloat(EventTotalAmount);
      console.log("TotalAmount=" + TotalAmount);

      if (validate1 && TotalCount > 0 && TotalAmount > 0) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/jci-program/order/create";
        var upload = {
          UserInterface: 1,
          RegistrationType: this.RegistrationTypeId,
          Lom: this.LomCode,
          Member: MemberId,
          Event: this.EventId,
          Plan: EventPlanId,
          MobileNo: selectedMember.MobileNo,
          EmailId: selectedMember.EmailId,
          Gender: selectedMember.Gender,
          FoodPreference: selectedMember.FoodChoice,
          GstNumberFlag: selectedMember.GstNumberFlag,
          GstNumber:
            selectedMember.GstNumberFlag == 1 ? selectedMember.GstNumber : null,
          TshirtSize: this.TshirtSize,
          PassportNumber: this.PassportNumber,
          SenatorNumber: this.SenatorNumber,
          TotalCount: TotalCount,
          TotalAmount: TotalAmount,
          UpgradeFlag: selectedPlan.UpgradeFlag || false,
          PlanTypeId: selectedPlan.UpgradeFlag ? 2 : 1,
          OldPlanId: selectedPlan.ExistingPlanId || null,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.SubmitFlag = true;
        this.ProgressLoadingFlag = true;

        // this.$session.set("checkout", upload);
        // this.checkout();

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SubmitFlag = false;
            thisIns.ProgressLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              /*
              thisIns.sweetAlert(
                "info",
                "You will be redirected to checkout page shortly",
                true
              );
              */
              thisIns.Order = records.Order;
              thisIns.makePayment();
            } else {
              // thisIns.toast("error", output);
              // thisIns.Order = records.Order;
              // thisIns.makePayment();
              thisIns.sweetAlert("info", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
            thisIns.ProgressLoadingFlag = false;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        if (TotalCount == 0) {
          message += "Kindly select member. ";
        }
        if (TotalAmount == 0) {
          message += "Kindly select a plan. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
    makePayment() {
      console.log("makePayment");
      // ev.preventDefault();
      var order = this.Order;
      console.log({ order });
      const thisIns = this;
      var rzp1 = new Razorpay({
        key: order.rzp_key,
        account_id: order.rzp_account_id,
        order_id: order.rzp_order_id,
        amount: order.rzp_amount,
        name: order.rzp_name,
        currency: "INR",
        description: order.rzp_description,
        image: order.rzp_image,
        theme: {
          color: order.rzp_color,
        },
        prefill: {
          name: order.customer_name,
          email: order.customer_email_id,
          contact: order.customer_mobile_no,
        },
        notes: {
          address: "",
        },
        // callback_url: "http://domain.com/#/about/" + this.order_id,
        redirect: false,
        handler: function (response) {
          console.log("razorpay_payment_id=" + response.razorpay_payment_id);
          thisIns.SubmitFlag = true;
          // thisIns.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
          thisIns.pageRedirect({}, "/order/success");
        },
      });
      rzp1.open();
    },
  },
  beforeMount() {
    this.refreshPageData();
    /*
    this.tableColumns1.push(
      { text: "Description", value: "Description" },
      { text: "Subscription Fees", value: "AmountTxt" },
      { text: "Nos", value: "Qty" },
      { text: "Sub Total", value: "SubTotal" }
      // { text: "Actions", value: "actions" }
    );
    */
  },
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap");

/* ==========================================================================
   JCSAT KIT PURCHASE SIGNATURE BLUE COLOR SYSTEM
   DEEP BLUE - #1E3A8A
   VIBRANT BLUE - #1565C0
   AQUA SKY - #0097D7
   GOLD ACCENT - #EDBE38
   SEAFOAM - #56BDA3
   Text: 90% Black (#414042), Off Black (#0A0F29), White (#FFFFFF)
   Background: Soft Light Blue-Grey (#F0F7FF)
   ========================================================================== */
$jci-deep-blue: #1e3a8a;
$jci-blue: #1565c0;
$jci-navy: #3a67b1;
$jci-aqua: #0097d7;
$jci-gold: #edbe38;
$jci-seafoam: #56bda3;

$jci-text-90black: #414042;
$jci-off-black: #0a0f29;
$jci-white: #ffffff;
$jci-bg-light: #f0f7ff;

#natcon-payment-create.natcon-luxury-app,
#natcon-member-payment-create.natcon-luxury-app,
#natcon-non-member-payment.natcon-luxury-app,
#natcon-member-payment.natcon-luxury-app {
  font-family: "Outfit", "Plus Jakarta Sans", sans-serif;
  background-color: $jci-bg-light;
  color: $jci-text-90black;
  min-height: 100vh;
  margin: -24px -24px 0 -24px;
  padding: 0;
  position: relative;
  overflow-x: hidden;

  /* Overrides for default Vuetify/Metronic card containers if wrapped */
  .v-card {
    background: transparent !important;
    box-shadow: none !important;
    border: none !important;
  }

  /* Overlay Spinner */
  .v-overlay.luxury-overlay {
    &:not(.v-overlay--active) {
      display: none !important;
    }

    &.v-overlay--active {
      backdrop-filter: blur(16px);
      -webkit-backdrop-filter: blur(16px);
      background: rgba(240, 247, 255, 0.9) !important;
    }

    .luxury-spinner-wrapper {
      text-align: center;
      .luxury-spinner-text {
        margin-top: 18px;
        color: $jci-blue;
        font-weight: 700;
        letter-spacing: 2px;
        text-transform: uppercase;
        font-size: 14px;
        animation: pulseText 1.8s infinite ease-in-out;
      }
    }
  }

  /* ==========================================================================
     1. HERO HEADER SECTION
     ========================================================================== */
  .luxury-hero-section {
    position: relative;
    min-height: 320px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 20px 48px 20px;
    background: linear-gradient(
      135deg,
      #1e3a8a 0%,
      #1565c0 50%,
      #0097d7 100%
    ) !important;
    background-size: 400% 400% !important;
    animation: gradientShift 15s ease infinite !important;
    overflow: hidden;
    color: #ffffff;

    /* Animated Background Layers */
    .mesh-gradient-bg {
      position: absolute;
      inset: 0;
      background: radial-gradient(
          at 0% 0%,
          rgba(30, 58, 138, 0.25) 0px,
          transparent 50%
        ),
        radial-gradient(
          at 100% 0%,
          rgba(21, 101, 192, 0.25) 0px,
          transparent 50%
        ),
        radial-gradient(
          at 50% 100%,
          rgba(237, 190, 56, 0.2) 0px,
          transparent 50%
        ),
        radial-gradient(
          at 100% 100%,
          rgba(0, 151, 215, 0.25) 0px,
          transparent 50%
        );
      filter: blur(40px);
      animation: meshMovement 20s ease-in-out infinite alternate;
      z-index: 1;
    }

    .aurora-lights {
      position: absolute;
      inset: 0;
      background: linear-gradient(
        125deg,
        rgba(255, 255, 255, 0.08),
        rgba(21, 101, 192, 0.06),
        rgba(0, 151, 215, 0.08)
      );
      background-size: 400% 400%;
      animation: auroraShift 15s ease infinite;
      z-index: 2;
    }

    .animated-glow-orbs {
      position: absolute;
      inset: 0;
      z-index: 2;
      pointer-events: none;

      .orb {
        position: absolute;
        border-radius: 50%;
        filter: blur(70px);
        opacity: 0.25;
      }
      .orb-1 {
        width: 220px;
        height: 220px;
        background: $jci-deep-blue;
        top: 10%;
        left: 15%;
        animation: floatOrb 12s ease-in-out infinite alternate;
      }
      .orb-2 {
        width: 260px;
        height: 260px;
        background: $jci-blue;
        bottom: 10%;
        right: 15%;
        animation: floatOrb 16s ease-in-out infinite alternate-reverse;
      }
      .orb-3 {
        width: 180px;
        height: 180px;
        background: $jci-gold;
        top: 40%;
        right: 35%;
        animation: floatOrb 10s ease-in-out infinite alternate;
      }
    }

    .moving-light-rays {
      position: absolute;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      background: conic-gradient(
        from 0deg at 50% 50%,
        rgba(255, 255, 255, 0.04) 0deg,
        transparent 60deg,
        rgba(0, 151, 215, 0.04) 120deg,
        transparent 180deg
      );
      animation: rotateRays 35s linear infinite;
      z-index: 2;
      pointer-events: none;
    }

    .glass-reflection-overlay {
      position: absolute;
      inset: 0;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.15) 0%,
        transparent 60%,
        rgba(240, 247, 255, 0.1) 100%
      );
      z-index: 3;
      pointer-events: none;
    }

    .soft-noise-overlay {
      position: absolute;
      inset: 0;
      opacity: 0.03;
      background-image: radial-gradient(#ffffff 1px, transparent 0);
      background-size: 24px 24px;
      z-index: 3;
      pointer-events: none;
    }

    /* Floating Decorative 3D Elements */
    .luxury-decorations {
      position: absolute;
      inset: 0;
      z-index: 4;
      pointer-events: none;

      .floating-element {
        position: absolute;
        opacity: 0.7;
      }

      .diamond {
        width: 20px;
        height: 20px;
        background: linear-gradient(135deg, #ffffff, rgba(0, 151, 215, 0.4));
        transform: rotate(45deg);
        box-shadow: 0 0 15px rgba(21, 101, 192, 0.25);
        border: 1px solid rgba(255, 255, 255, 0.3);
        border-radius: 4px;
        &.d1 {
          top: 15%;
          left: 8%;
          animation: floatSlow 8s ease-in-out infinite;
        }
      }

      .ring {
        width: 36px;
        height: 36px;
        border: 2px solid rgba(237, 190, 56, 0.5);
        border-radius: 50%;
        box-shadow: 0 0 20px rgba(237, 190, 56, 0.2);
        &.r1 {
          bottom: 20%;
          left: 12%;
          animation: floatSlow 11s ease-in-out infinite reverse;
        }
      }

      .circle {
        width: 14px;
        height: 14px;
        background: rgba(0, 151, 215, 0.5);
        border-radius: 50%;
        box-shadow: 0 0 12px rgba(0, 151, 215, 0.6);
        &.c1 {
          top: 22%;
          right: 10%;
          animation: floatSlow 9s ease-in-out infinite;
        }
      }

      .cube {
        width: 22px;
        height: 22px;
        background: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(8px);
        border: 1px solid rgba(255, 255, 255, 0.25);
        border-radius: 6px;
        transform: rotate(15deg);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
        &.cb1 {
          bottom: 25%;
          right: 8%;
          animation: floatSlow 13s ease-in-out infinite;
        }
      }

      .golden-particle {
        width: 6px;
        height: 6px;
        background: $jci-gold;
        border-radius: 50%;
        box-shadow: 0 0 10px $jci-gold;
        &.p1 {
          top: 35%;
          left: 5%;
          animation: floatSlow 6s ease-in-out infinite;
        }
        &.p2 {
          top: 12%;
          right: 22%;
          animation: floatSlow 7s ease-in-out infinite reverse;
        }
      }

      .sparkle {
        color: $jci-gold;
        font-size: 15px;
        text-shadow: 0 0 12px $jci-gold;
        &.s1 {
          top: 18%;
          left: 25%;
          animation: pulseGlow 3s infinite alternate;
        }
        &.s2 {
          bottom: 30%;
          right: 25%;
          animation: pulseGlow 4s infinite alternate 1s;
        }
        &.s3 {
          top: 45%;
          right: 6%;
          animation: pulseGlow 2.5s infinite alternate 0.5s;
        }
      }

      .line {
        width: 90px;
        height: 1px;
        background: linear-gradient(
          90deg,
          transparent,
          rgba(255, 255, 255, 0.4),
          transparent
        );
        &.l1 {
          top: 28%;
          right: 18%;
          transform: rotate(-25deg);
          animation: floatSlow 10s ease-in-out infinite;
        }
      }

      .glow-wave {
        width: 150px;
        height: 150px;
        border-radius: 50%;
        border: 1px solid rgba(255, 255, 255, 0.2);
        &.w1 {
          bottom: 10%;
          left: 30%;
          animation: pulseGlow 6s infinite alternate;
        }
      }
    }

    /* Hero Content & Glass Card - JCSAT KIT PURCHASE BLUE GRADIENT */
    .hero-content-wrapper {
      position: relative;
      z-index: 5;
      max-width: 1140px;
      width: 100%;
      text-align: center;

      .hero-glass-card {
        position: relative;
        background: rgba(255, 255, 255, 0.12);
        backdrop-filter: blur(28px);
        -webkit-backdrop-filter: blur(28px);
        border: 1px solid rgba(255, 255, 255, 0.25);
        border-radius: 24px;
        padding: 24px 28px;
        box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2),
          inset 0 1px 0 rgba(255, 255, 255, 0.4);
        overflow: hidden;
        animation: heroCardBreathing 8s ease-in-out infinite alternate;

        /* Floating 3D Glassy Bubble Animations */
        .hero-bubbles {
          position: absolute;
          inset: 0;
          overflow: hidden;
          pointer-events: none;
          z-index: 1;

          .bubble {
            position: absolute;
            bottom: -60px;
            border-radius: 50%;
            background: radial-gradient(
              circle at 32% 32%,
              rgba(255, 255, 255, 0.9) 0%,
              rgba(255, 255, 255, 0.4) 22%,
              rgba(0, 151, 215, 0.25) 50%,
              rgba(30, 58, 138, 0.15) 75%,
              rgba(255, 255, 255, 0.6) 100%
            );
            box-shadow: inset -4px -4px 12px rgba(255, 255, 255, 0.8),
              inset 4px 4px 14px rgba(0, 151, 215, 0.5),
              inset 0 -8px 18px rgba(237, 190, 56, 0.35),
              0 8px 25px rgba(0, 0, 0, 0.25), 0 0 15px rgba(255, 255, 255, 0.5);
            border: 1px solid rgba(255, 255, 255, 0.6);
            backdrop-filter: blur(4px);
            animation: floatUp3DBubble linear infinite;

            &::before {
              content: "";
              position: absolute;
              top: 14%;
              left: 16%;
              width: 28%;
              height: 28%;
              border-radius: 50%;
              background: radial-gradient(
                circle,
                #ffffff 0%,
                rgba(255, 255, 255, 0.8) 50%,
                transparent 100%
              );
              filter: blur(0.5px);
            }

            &::after {
              content: "";
              position: absolute;
              bottom: 12%;
              right: 14%;
              width: 40%;
              height: 20%;
              border-radius: 50%;
              background: rgba(255, 255, 255, 0.5);
              filter: blur(1.5px);
              transform: rotate(-30deg);
            }
          }

          .bubble-1 {
            width: 48px;
            height: 48px;
            left: 8%;
            animation-duration: 7s;
            animation-delay: 0s;
          }
          .bubble-2 {
            width: 32px;
            height: 32px;
            left: 24%;
            animation-duration: 9s;
            animation-delay: 1.5s;
          }
          .bubble-3 {
            width: 60px;
            height: 60px;
            left: 45%;
            animation-duration: 6s;
            animation-delay: 3s;
          }
          .bubble-4 {
            width: 28px;
            height: 28px;
            left: 65%;
            animation-duration: 8s;
            animation-delay: 0.5s;
          }
          .bubble-5 {
            width: 52px;
            height: 52px;
            left: 82%;
            animation-duration: 10s;
            animation-delay: 2s;
          }
          .bubble-6 {
            width: 36px;
            height: 36px;
            left: 93%;
            animation-duration: 7.5s;
            animation-delay: 4s;
          }
        }

        .hero-card-glow-border {
          position: absolute;
          inset: 0;
          border-radius: 24px;
          padding: 1px;
          background: linear-gradient(
            135deg,
            rgba(237, 190, 56, 0.8),
            transparent 40%,
            rgba(255, 255, 255, 0.6)
          );
          -webkit-mask: linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
          -webkit-mask-composite: destination-out;
          mask-composite: exclude;
          pointer-events: none;
        }

        .hero-card-shine-sweep {
          position: absolute;
          top: 0;
          left: -150%;
          width: 80%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.25),
            transparent
          );
          transform: skewX(-25deg);
          animation: shineSweep 9s infinite ease-in-out;
          pointer-events: none;
        }

        /* Badge */
        .hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 4px 14px;
          background: rgba(255, 255, 255, 0.18);
          border: 1px solid rgba(255, 255, 255, 0.4);
          border-radius: 100px;
          margin-bottom: 12px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);

          .badge-icon {
            font-size: 12px;
          }
          .badge-text {
            font-size: 10px;
            font-weight: 800;
            letter-spacing: 1.5px;
            color: $jci-gold;
            text-transform: uppercase;
          }
        }

        /* Typography */
        .hero-main-title {
          font-size: clamp(24px, 3.5vw, 36px);
          font-weight: 900;
          line-height: 1.15;
          letter-spacing: -0.5px;
          margin-bottom: 8px;
          color: $jci-white;
          background: none;
          -webkit-text-fill-color: $jci-white;
          text-shadow: 0 4px 15px rgba(0, 0, 0, 0.25);

          .text-gradient-sky {
            background: linear-gradient(90deg, #ffd54f 0%, #fff176 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-weight: 850;
          }
        }

        .hero-subtitle {
          font-size: 14px;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.95);
          max-width: 900px;
          margin: 0 auto 16px auto;
          line-height: 1.5;
        }

        /* Information Glass Pills */
        .hero-pills-row {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 8px;
          margin-bottom: 18px;

          .hero-pill {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 6px 14px;
            background: rgba(255, 255, 255, 0.15);
            backdrop-filter: blur(12px);
            border: 1.5px solid #0097d7 !important;
            border-radius: 100px;
            font-size: 12px;
            color: #ffffff !important;
            box-shadow: 0 4px 12px rgba(0, 151, 215, 0.25);
            transition: all 0.3s ease;

            .pill-icon,
            i {
              font-size: 14px;
              color: #ffffff !important;
            }

            &:hover {
              background: rgba(255, 255, 255, 0.25);
              border-color: #ffffff !important;
              transform: translateY(-2px);
              box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2);
            }

            &.live-status {
              background: rgba(86, 189, 163, 0.25);
              border-color: rgba(86, 189, 163, 0.8) !important;
              color: #ffffff !important;

              .status-dot {
                width: 7px;
                height: 7px;
                background: #ffffff;
                border-radius: 50%;
                box-shadow: 0 0 8px #ffffff;
                animation: pulseGlow 1.5s infinite alternate;
              }
            }
          }
        }

        /* Hero Action Buttons */
        .hero-actions-row {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 12px;

          .non-member-link {
            text-decoration: none;
          }

          .glass-btn {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            padding: 10px 20px;
            border-radius: 12px;
            font-size: 13px;
            font-weight: 700;
            cursor: pointer;
            transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
            position: relative;
            overflow: hidden;

            .btn-icon,
            i {
              font-size: 16px;
              color: #ffffff !important;
            }

            &.primary-glass-btn {
              background: linear-gradient(135deg, #edbe38 0%, #d49b1f 100%);
              color: $jci-off-black;
              border: none;
              box-shadow: 0 6px 18px rgba(237, 190, 56, 0.35);

              .btn-icon,
              i {
                color: $jci-off-black !important;
              }

              &:hover {
                transform: translateY(-2px) scale(1.02);
                box-shadow: 0 10px 25px rgba(237, 190, 56, 0.5);
              }
            }

            &.secondary-glass-btn {
              background: rgba(255, 255, 255, 0.2);
              color: $jci-white;
              border: 1px solid rgba(255, 255, 255, 0.4);
              box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);

              &:hover {
                background: rgba(255, 255, 255, 0.35);
                color: $jci-white;
                border-color: #ffffff;
                transform: translateY(-2px) scale(1.02);
                box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
              }
            }

            &.emerald-glass-btn {
              background: linear-gradient(135deg, #56bda3 0%, #0f766e 100%);
              color: $jci-white;
              border: none;
              box-shadow: 0 6px 18px rgba(86, 189, 163, 0.35);

              &:hover {
                transform: translateY(-2px) scale(1.02);
                box-shadow: 0 10px 25px rgba(86, 189, 163, 0.5);
              }
            }
          }
        }
      }

      /* Scroll Indicator */
      .hero-scroll-indicator {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
        opacity: 0.85;
        transition: opacity 0.3s;

        &:hover {
          opacity: 1;
        }

        .mouse-icon {
          width: 20px;
          height: 32px;
          border: 2px solid rgba(255, 255, 255, 0.6);
          border-radius: 10px;
          position: relative;

          .wheel {
            width: 3px;
            height: 6px;
            background: #ffffff;
            border-radius: 2px;
            position: absolute;
            top: 5px;
            left: 50%;
            transform: translateX(-50%);
            animation: scrollWheel 1.8s infinite ease-in-out;
          }
        }

        .scroll-arrow {
          font-size: 14px;
          color: #ffffff;
          animation: arrowPulse 1.5s infinite ease-in-out;
        }

        .scroll-text {
          font-size: 9px;
          font-weight: 700;
          letter-spacing: 1.5px;
          color: rgba(255, 255, 255, 0.9);
          text-transform: uppercase;
        }
      }
    }
  }

  /* ==========================================================================
     2. STATISTICS SECTION
     ========================================================================== */
  .luxury-stats-bar {
    margin-top: -30px;
    position: relative;
    z-index: 10;
    padding: 0 24px;

    .stats-container {
      max-width: 1140px;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
      gap: 16px;

      .stat-card {
        background: #ffffff;
        backdrop-filter: blur(20px);
        border: 2px solid #1565c0 !important;
        border-radius: 20px;
        padding: 20px;
        display: flex;
        align-items: center;
        gap: 16px;
        box-shadow: 0 10px 30px rgba(21, 101, 192, 0.15);
        transition: all 0.35s ease;

        &:hover {
          transform: translateY(-4px);
          border-color: $jci-aqua !important;
          box-shadow: 0 15px 35px rgba(0, 151, 215, 0.18);
        }

        .stat-icon-box {
          width: 50px;
          height: 50px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          background: linear-gradient(
            135deg,
            #1e3a8a 0%,
            #1565c0 100%
          ) !important;
          color: #ffffff !important;
          box-shadow: 0 4px 12px rgba(21, 101, 192, 0.25);

          i {
            color: #ffffff !important;
          }

          &.gold {
            background: linear-gradient(
              135deg,
              #edbe38 0%,
              #d49b1f 100%
            ) !important;
          }
          &.purple {
            background: linear-gradient(
              135deg,
              #1e3a8a 0%,
              #3a67b1 100%
            ) !important;
          }
          &.blue {
            background: linear-gradient(
              135deg,
              #1565c0 0%,
              #0097d7 100%
            ) !important;
          }
          &.emerald {
            background: linear-gradient(
              135deg,
              #56bda3 0%,
              #0f766e 100%
            ) !important;
          }
        }

        .stat-info {
          .stat-value {
            font-size: 18px;
            font-weight: 800;
            color: $jci-off-black;
            line-height: 1.2;
          }
          .stat-label {
            font-size: 12px;
            color: $jci-text-90black;
            margin-top: 2px;
          }
        }
      }
    }
  }

  /* ==========================================================================
     3. MAIN BODY & FORM CONTENT
     ========================================================================== */
  .luxury-main-content {
    padding: 40px 24px 80px 24px;

    .content-container {
      max-width: 1140px;
      margin: 0 auto;
    }

    /* EXECUTIVE LOM & PRESIDENT CARD - JCSAT BLUE GRADIENT */
    .executive-pass-card {
      .pass-card-glass {
        background: linear-gradient(
          135deg,
          #1e3a8a 0%,
          #1565c0 50%,
          #0097d7 100%
        ) !important;
        background-size: 400% 400% !important;
        animation: gradientShift 15s ease infinite !important;
        backdrop-filter: blur(24px);
        border: 1px solid rgba(255, 255, 255, 0.25);
        border-radius: 24px;
        padding: 24px 30px;
        box-shadow: 0 20px 45px rgba(21, 101, 192, 0.2);
        position: relative;
        overflow: hidden;

        &::before {
          content: "";
          position: absolute;
          top: 0;
          right: 0;
          width: 150px;
          height: 150px;
          background: radial-gradient(
            circle,
            rgba(255, 255, 255, 0.15) 0%,
            transparent 70%
          );
          pointer-events: none;
        }

        .pass-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid rgba(255, 255, 255, 0.2);
          padding-bottom: 14px;
          margin-bottom: 20px;

          .pass-brand {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 11px;
            font-weight: 800;
            letter-spacing: 1.5px;
            color: $jci-gold;

            .pass-brand-icon {
              font-size: 16px;
            }
          }

          .pass-badge {
            font-size: 10px;
            font-weight: 800;
            padding: 4px 10px;
            background: rgba(255, 255, 255, 0.18);
            border-radius: 6px;
            color: $jci-white;
            letter-spacing: 1px;
          }
        }

        .pass-body {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: center;
          gap: 20px;

          .pass-label {
            font-size: 11px;
            text-transform: uppercase;
            letter-spacing: 1px;
            color: rgba(255, 255, 255, 0.85);
            margin-bottom: 4px;
          }

          .pass-value-lg {
            font-size: 20px;
            font-weight: 800;
            color: $jci-white;
          }

          .pass-value {
            font-size: 16px;
            font-weight: 700;
            color: $jci-white;
          }

          .pass-sublabel {
            font-size: 13px;
            color: $jci-gold;
            font-weight: 600;
          }

          .president-col {
            display: flex;
            align-items: center;
            gap: 16px;

            .pass-avatar-wrapper {
              width: 56px;
              height: 56px;
              border-radius: 50%;
              padding: 2px;
              background: linear-gradient(135deg, $jci-gold, #ffffff);
              box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);

              .president-avatar {
                border-radius: 50%;
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
          }
        }
      }
    }

    /* GLASS FORM CARD & HEADER - JCSAT BLUE GRADIENT */
    .glass-form-card {
      background: #ffffff;
      backdrop-filter: blur(24px);
      border: 1px solid rgba(21, 101, 192, 0.18);
      border-radius: 24px;
      padding: 30px;
      box-shadow: 0 15px 40px rgba(21, 101, 192, 0.08);

      .glass-card-header {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 24px;
        background: linear-gradient(
          135deg,
          #1e3a8a 0%,
          #1565c0 50%,
          #0097d7 100%
        ) !important;
        background-size: 400% 400% !important;
        animation: gradientShift 15s ease infinite !important;
        padding: 16px 24px;
        border-radius: 16px;
        box-shadow: 0 10px 25px rgba(21, 101, 192, 0.25);

        .header-icon-box {
          width: 44px;
          height: 44px;
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.2);
          color: #ffffff !important;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px;

          i,
          .v-icon {
            color: #ffffff !important;
          }
        }

        .glass-card-title {
          font-size: 20px;
          font-weight: 800;
          color: $jci-white;
          margin: 0;
        }

        .glass-card-subtitle {
          font-size: 13px;
          color: rgba(255, 255, 255, 0.85);
          margin: 2px 0 0 0;
        }
      }
    }

    /* LUXURY FORM DIRECTIVES & INPUT STYLES */
    .luxury-field-group {
      margin-bottom: 8px;

      .luxury-label {
        display: block;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.5px;
        color: $jci-off-black;
        margin-bottom: 8px;

        .req-star {
          color: #f43f5e;
          font-weight: 900;
        }
        small {
          color: $jci-text-90black;
          font-weight: 400;
        }
      }

      /* Vuetify Input Overrides */
      .v-text-field.v-text-field--outlined.luxury-input,
      .v-select.v-select--outlined.luxury-input,
      .v-autocomplete.v-select--outlined.luxury-input {
        fieldset {
          border-color: rgba(21, 101, 192, 0.25) !important;
          border-radius: 14px !important;
          transition: all 0.3s ease;
        }

        .v-input__control .v-input__slot {
          background: #f8fafc !important;
          border-radius: 14px !important;
          min-height: 48px !important;
        }

        input,
        .v-select__selection {
          color: $jci-off-black !important;
          font-size: 14px !important;
          font-weight: 600 !important;
        }

        .v-label {
          color: $jci-text-90black !important;
        }

        &.v-input--is-focused fieldset {
          border-color: $jci-blue !important;
          box-shadow: 0 0 12px rgba(21, 101, 192, 0.2) !important;
        }
      }

      .member-autocomplete {
        .member-select-item {
          display: flex;
          align-items: center;
          gap: 10px;

          .member-thumb {
            border-radius: 50%;
            object-fit: cover;
            border: 1px solid $jci-blue;
          }
          .member-text {
            font-size: 14px;
            color: $jci-off-black;
            font-weight: 600;
          }
        }
      }
    }

    /* ==========================================================================
       4. VIP IDENTITY PASS CARD - JCSAT BLUE GRADIENT
       ========================================================================== */
    .vip-identity-section {
      .vip-card {
        background: #ffffff !important;
        backdrop-filter: blur(28px);
        border: 1px solid rgba(21, 101, 192, 0.18);
        border-radius: 28px;
        padding: 0 0 32px 0;
        box-shadow: 0 15px 40px rgba(21, 101, 192, 0.08);
        position: relative;
        overflow: hidden;

        .vip-card-glow {
          position: absolute;
          top: -50px;
          right: -50px;
          width: 250px;
          height: 250px;
          background: radial-gradient(
            circle,
            rgba(21, 101, 192, 0.08) 0%,
            transparent 70%
          );
          pointer-events: none;
        }

        .vip-card-shine {
          position: absolute;
          top: 0;
          left: -100%;
          width: 50%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.2),
            transparent
          );
          transform: skewX(-20deg);
          animation: shineSweep 8s infinite;
          pointer-events: none;
        }

        .vip-card-top {
          background: linear-gradient(
            135deg,
            #1e3a8a 0%,
            #1565c0 50%,
            #0097d7 100%
          ) !important;
          background-size: 400% 400% !important;
          animation: gradientShift 15s ease infinite !important;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px 28px;
          margin-bottom: 24px;
          border-top-left-radius: 26px;
          border-top-right-radius: 26px;

          .vip-badge-tag {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            font-size: 11px;
            font-weight: 800;
            letter-spacing: 1.5px;
            color: $jci-off-black;
            background: $jci-gold;
            padding: 6px 14px;
            border-radius: 100px;
            border: none;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

            i,
            .v-icon {
              color: #ffffff !important;
            }
          }

          .vip-chip-logo {
            font-size: 12px;
            font-weight: 900;
            letter-spacing: 2px;
            color: rgba(255, 255, 255, 0.95);
          }
        }

        .vip-card-main {
          display: flex;
          align-items: center;
          gap: 24px;
          margin-bottom: 32px;
          padding: 0 32px;

          .vip-photo-frame {
            width: 100px;
            height: 100px;
            border-radius: 20px;
            padding: 3px;
            background: linear-gradient(135deg, $jci-blue, $jci-aqua);
            box-shadow: 0 8px 20px rgba(21, 101, 192, 0.15);

            .vip-photo {
              border-radius: 17px;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .vip-member-info {
            .vip-name {
              font-size: 24px;
              font-weight: 800;
              color: $jci-off-black;
              margin-bottom: 6px;
            }

            .vip-id-pill {
              display: inline-flex;
              align-items: center;
              gap: 6px;
              font-size: 13px;
              color: $jci-text-90black;
              margin-bottom: 8px;

              i {
                color: $jci-blue;
              }
            }

            .vip-status-chip {
              display: flex;
              align-items: center;
              gap: 6px;
              font-size: 12px;
              font-weight: 700;
              color: #0f766e;

              .chip-dot {
                width: 6px;
                height: 6px;
                background: #56bda3;
                border-radius: 50%;
                box-shadow: 0 0 8px #56bda3;
              }
            }
          }
        }

        .vip-form-grid {
          border-top: 1px dashed rgba(21, 101, 192, 0.2);
          padding: 24px 32px 0 32px;
        }
      }
    }

    /* ==========================================================================
       5. PREMIUM PLAN CARDS SECTION
       ========================================================================== */
    .plans-section-header {
      text-align: center;
      margin: 60px 0 40px 0;

      .section-badge {
        display: inline-block;
        font-size: 11px;
        font-weight: 800;
        letter-spacing: 2.5px;
        color: $jci-navy;
        background: rgba(58, 103, 177, 0.12);
        padding: 6px 16px;
        border-radius: 100px;
        border: 1px solid rgba(58, 103, 177, 0.3);
        margin-bottom: 12px;
      }

      .section-title {
        font-size: clamp(26px, 3.5vw, 38px);
        font-weight: 900;
        color: $jci-off-black;
        letter-spacing: -0.5px;
      }

      .section-subtitle {
        font-size: 15px;
        color: $jci-text-90black;
        margin-top: 4px;
      }

      .global-existing-plan-banner {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        background: linear-gradient(
          135deg,
          #1e3a8a 0%,
          #1565c0 50%,
          #0097d7 100%
        );
        color: #ffffff;
        padding: 10px 24px;
        border-radius: 30px;
        font-size: 14px;
        font-weight: 700;
        margin-top: 16px;
        box-shadow: 0 8px 25px rgba(21, 101, 192, 0.25);
        border: 1.5px solid rgba(255, 255, 255, 0.4);

        i {
          font-size: 18px;
          color: #ffd54f !important;
        }

        strong {
          color: #ffd54f;
          font-weight: 800;
          margin-left: 4px;
        }
      }
    }

    .plans-grid-row {
      .plan-card-col {
        display: flex;
        justify-content: center;
      }

      .cards-box {
        margin-top: 10px;
        width: 100%;
        max-width: 320px;

        .outside-existing-plan-badge {
          background: #ffffff;
          border: 1.5px solid #1565c0;
          border-radius: 14px;
          padding: 8px 12px;
          text-align: center;
          font-size: 12px;
          font-weight: 700;
          color: #0a0f29;
          box-shadow: 0 4px 15px rgba(21, 101, 192, 0.15);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          margin-bottom: 12px;
          width: 100%;

          i {
            color: #1565c0;
            font-size: 16px;
          }

          strong {
            color: #1565c0;
            font-weight: 800;
          }
        }
      }

      /* Base Cards Redesign: Whole Card JCSAT Order Summary Header Blue Gradient */
      .cards.luxury-plan-card {
        position: relative;
        background: linear-gradient(
          135deg,
          #1e3a8a 0%,
          #1565c0 50%,
          #0097d7 100%
        ) !important;
        background-size: 400% 400% !important;
        animation: gradientShift 15s ease infinite,
          planCardBreathing 8s ease-in-out infinite alternate !important;
        backdrop-filter: blur(24px);
        -webkit-backdrop-filter: blur(24px);
        border: 1.5px solid rgba(255, 255, 255, 0.3) !important;
        border-radius: 28px !important;
        padding: 32px 24px 28px 24px !important;
        width: 100% !important;
        min-height: 440px;
        height: auto !important;
        margin: 0 !important;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        color: #ffffff !important;
        box-shadow: 0 20px 50px rgba(21, 101, 192, 0.25) !important;
        transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        overflow: hidden;

        &:hover {
          transform: translateY(-10px) scale(1.02);
          box-shadow: 0 30px 65px rgba(0, 151, 215, 0.35) !important;
          border-color: #ffd54f !important;
        }

        /* Silvery Metallic Sheen Effect */
        .silvery-shine-sweep {
          position: absolute;
          top: -50%;
          left: -150%;
          width: 100%;
          height: 200%;
          background: linear-gradient(
            105deg,
            transparent 0%,
            rgba(255, 255, 255, 0) 30%,
            rgba(255, 255, 255, 0.45) 45%,
            rgba(240, 248, 255, 0.95) 50%,
            rgba(255, 255, 255, 0.45) 55%,
            rgba(255, 255, 255, 0) 70%,
            transparent 100%
          );
          transform: rotate(25deg);
          animation: silverShineSweep 6s infinite ease-in-out;
          pointer-events: none;
          z-index: 5;
        }

        .card-shimmer-sweep {
          position: absolute;
          top: 0;
          left: -150%;
          width: 80%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.35),
            transparent
          );
          transform: skewX(-25deg);
          animation: shineSweep 7s infinite ease-in-out;
          pointer-events: none;
        }

        /* Mild Inner Card Ambient Aura Glow */
        .card-glow-aura {
          position: absolute;
          top: -30%;
          right: -30%;
          width: 200px;
          height: 200px;
          background: radial-gradient(
            circle,
            rgba(255, 255, 255, 0.25) 0%,
            rgba(0, 151, 215, 0.15) 50%,
            transparent 75%
          );
          pointer-events: none;
          animation: pulseGlow 4s infinite alternate ease-in-out;
        }

        /* Unified Card Title & Subtitle Alignment */
        .cards-title-bar {
          background: none !important;
          padding: 0;
          margin-bottom: 16px;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;

          .cards-title {
            font-size: 24px !important;
            font-weight: 900;
            color: #ffffff !important;
            text-transform: none !important;
            letter-spacing: -0.5px;
            margin: 0;
            text-align: center;
            width: 100%;
            text-shadow: 0 3px 12px rgba(0, 0, 0, 0.3);

            &.gold-title {
              color: #ffd54f !important;
              text-shadow: 0 3px 12px rgba(0, 0, 0, 0.4);
            }

            &.emerald-title {
              color: #ffffff !important;
            }
          }

          .cards-subtitle {
            font-size: 13px !important;
            color: rgba(255, 255, 255, 0.95) !important;
            margin-top: 6px;
            font-weight: 500;
            line-height: 1.4;
            text-align: center;
            width: 100%;
          }

          .upgrade-info-card {
            width: 100%;
            background: rgba(10, 15, 41, 0.35);
            backdrop-filter: blur(12px);
            border: 1px solid rgba(255, 255, 255, 0.3);
            border-radius: 18px;
            padding: 14px 16px;
            margin-top: 12px;
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2),
              inset 0 1px 0 rgba(255, 255, 255, 0.2);

            .upgrade-badge-header {
              text-align: center;
              margin-bottom: 10px;

              .upgrade-pill {
                font-size: 11px !important;
                font-weight: 800 !important;
                letter-spacing: 0.5px;
                padding: 4px 12px;
              }
            }

            .existing-plan-banner {
              background: rgba(255, 255, 255, 0.15);
              border-radius: 12px;
              padding: 8px 12px;
              margin-bottom: 10px;
              text-align: center;
              border: 1px solid rgba(255, 255, 255, 0.25);

              .existing-label {
                display: block;
                font-size: 10px;
                font-weight: 800;
                text-transform: uppercase;
                letter-spacing: 1px;
                color: #ffd54f;
                margin-bottom: 2px;
              }

              .existing-name-full {
                font-size: 13px;
                font-weight: 800;
                color: #ffffff;
                line-height: 1.35;
                word-break: break-word;
              }
            }

            .upgrade-details-list {
              display: flex;
              flex-direction: column;
              gap: 8px;

              .upgrade-detail-row {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 8px;
                font-size: 13px;
                line-height: 1.3;

                .detail-label {
                  font-weight: 600;
                  color: rgba(255, 255, 255, 0.85);
                  font-size: 13px;
                }

                .detail-value {
                  font-weight: 800;
                  color: #ffffff;
                  font-size: 14px;
                  text-align: right;

                  &.highlight-gold {
                    color: #ffd54f !important;
                    font-weight: 900;
                    font-size: 15px;
                  }

                  &.highlight-emerald {
                    color: #56bda3 !important;
                    font-weight: 900;
                    font-size: 14px;
                  }
                }
              }
            }
          }
        }

        /* Popular / Recommended Card Accent */
        &.recommended-card {
          border: 2px solid $jci-gold !important;
          box-shadow: 0 20px 50px rgba(237, 190, 56, 0.25) !important;
        }

        /* Upgrade Plan Card Accent */
        &.emerald-upgrade-card {
          border: 2px solid #56bda3 !important;
        }

        /* Pricing Area Alignment */
        .cards-price {
          margin: 16px 0 !important;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;

          .upgrade-pending-txt {
            color: #ffd54f !important;
            text-align: center;
            width: 100%;
            font-size: 13px;
            font-weight: 800;
          }

          .cards-price-amount {
            font-size: 34px !important;
            font-weight: 900;
            color: #ffffff !important;
            text-align: center;
            width: 100%;
            text-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);

            .cards-price-validity {
              display: block;
              font-size: 11px !important;
              letter-spacing: 1.5px;
              color: rgba(255, 255, 255, 0.85) !important;
              margin-top: 4px;
              text-align: center;
              width: 100%;
            }

            .cards-price-gst {
              display: block;
              font-size: 13px !important;
              color: #ffd54f !important;
              font-weight: 800;
              text-align: center;
              width: 100%;
            }
          }

          .show-details-btn {
            font-size: 11px !important;
            font-weight: 700;
            letter-spacing: 0.5px;
            text-transform: none;
            color: #ffffff !important;
            border-color: rgba(255, 255, 255, 0.6) !important;
            background: rgba(255, 255, 255, 0.15) !important;
            margin: 10px auto 0 auto;
            transition: all 0.3s ease;

            i {
              color: #ffffff !important;
            }

            &:hover {
              background: rgba(255, 255, 255, 0.3) !important;
              border-color: #ffffff !important;
              transform: translateY(-2px);
            }
          }
        }

        /* Total Section Alignment */
        .cards-total-box {
          margin-top: 16px;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;

          .total-divider {
            height: 1px;
            width: 80%;
            margin: 0 auto 12px auto;
            background: linear-gradient(
              90deg,
              transparent,
              rgba(255, 255, 255, 0.4),
              transparent
            );
          }

          .total-amount-display {
            font-size: 28px !important;
            font-weight: 900;
            color: #ffd54f !important;
            text-align: center;
            width: 100%;
            text-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
          }
        }

        /* Action Pay Buttons Alignment */
        .cards-action {
          width: 100%;
          margin-top: 16px;
          display: flex;
          justify-content: center;
          align-items: center;

          .cards-action-button {
            width: 100%;
            height: 52px !important;
            border-radius: 16px !important;
            font-size: 14px !important;
            font-weight: 800 !important;
            letter-spacing: 0.5px;
            text-transform: uppercase;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            cursor: pointer;
            transition: all 0.35s ease;
            position: relative;
            overflow: hidden;
            background: linear-gradient(
              135deg,
              #edbe38 0%,
              #d49b1f 100%
            ) !important;
            color: $jci-off-black !important;
            border: none !important;
            box-shadow: 0 10px 25px rgba(237, 190, 56, 0.4);

            .btn-arrow,
            i {
              color: $jci-off-black !important;
            }

            &:hover:not(:disabled) {
              transform: translateY(-2px);
              box-shadow: 0 15px 35px rgba(237, 190, 56, 0.6);
            }

            &.emerald-action-btn {
              background: linear-gradient(
                135deg,
                #56bda3 0%,
                #0f766e 100%
              ) !important;
              color: #ffffff !important;
              box-shadow: 0 10px 25px rgba(86, 189, 163, 0.4);

              .btn-arrow,
              i {
                color: #ffffff !important;
              }
            }
          }
        }
      }

      /* RECOMMENDED CARD SPECIFIC STYLING */
      .recommended-card {
        border: 2px solid $jci-gold !important;
        box-shadow: 0 20px 50px rgba(237, 190, 56, 0.35) !important;

        .card-glow-aura {
          position: absolute;
          inset: -2px;
          border-radius: 30px;
          background: radial-gradient(
            circle at 50% 0%,
            rgba(237, 190, 56, 0.15) 0%,
            transparent 60%
          );
          pointer-events: none;
        }

        /* 3D Folded Metallic Gold Ribbon */
        .luxury-3d-ribbon {
          position: absolute;
          top: 18px;
          right: -32px;
          width: 140px;
          background: linear-gradient(
            135deg,
            #edbe38 0%,
            #fff3b0 30%,
            #d49b1f 70%,
            #edbe38 100%
          );
          transform: rotate(45deg);
          padding: 6px 0;
          text-align: center;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
          z-index: 10;
          overflow: hidden;

          span {
            font-size: 10px;
            font-weight: 900;
            letter-spacing: 1px;
            color: $jci-off-black;
            text-transform: uppercase;
            display: block;
          }

          .ribbon-shine {
            position: absolute;
            top: 0;
            left: -100%;
            width: 50%;
            height: 100%;
            background: linear-gradient(
              90deg,
              transparent,
              rgba(255, 255, 255, 0.6),
              transparent
            );
            transform: skewX(-20deg);
            animation: shineSweep 4s infinite;
          }
        }
      }

      /* EMERALD UPGRADE CARD STYLING */
      .emerald-upgrade-card {
        background: linear-gradient(
          135deg,
          #ffffff 0%,
          #f0fdf4 100%
        ) !important;
        border: 2px solid $jci-seafoam !important;
        box-shadow: 0 20px 50px rgba(86, 189, 163, 0.2) !important;

        .upgrade-chip-box {
          background: rgba(86, 189, 163, 0.15);
          border: 1px solid rgba(86, 189, 163, 0.35);
          border-radius: 12px;
          padding: 10px;
          margin: 10px 0;

          .upgrade-pill {
            font-size: 10px !important;
            letter-spacing: 1px;
          }

          .upgrade-txt-sub {
            font-size: 11px;
            color: $jci-text-90black;
            margin-top: 2px;
          }
        }
      }
    }
  }

  /* Preview Plan Modal Glass Override */
  .luxury-preview-modal {
    border-radius: 24px !important;
    overflow: hidden !important;
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.3) !important;
  }
}

/* ==========================================================================
   KEYFRAME ANIMATIONS
   ========================================================================== */
@keyframes meshMovement {
  0% {
    transform: scale(1) translate(0, 0);
  }
  50% {
    transform: scale(1.1) translate(-2%, 2%);
  }
  100% {
    transform: scale(1) translate(2%, -2%);
  }
}

@keyframes auroraShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes floatOrb {
  0% {
    transform: translateY(0px) scale(1);
  }
  100% {
    transform: translateY(-30px) scale(1.08);
  }
}

@keyframes rotateRays {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes floatSlow {
  0% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-15px) rotate(5deg);
  }
  100% {
    transform: translateY(0) rotate(0deg);
  }
}

@keyframes pulseGlow {
  0% {
    opacity: 0.4;
    transform: scale(0.98);
  }
  100% {
    opacity: 1;
    transform: scale(1.05);
  }
}

@keyframes heroCardBreathing {
  0% {
    transform: translateY(0);
    box-shadow: 0 20px 60px rgba(58, 103, 177, 0.12);
  }
  100% {
    transform: translateY(-6px);
    box-shadow: 0 30px 70px rgba(58, 103, 177, 0.18);
  }
}

@keyframes silverShineSweep {
  0% {
    left: -150%;
  }
  25% {
    left: 150%;
  }
  100% {
    left: 150%;
  }
}

@keyframes shineSweep {
  0% {
    left: -150%;
  }
  30% {
    left: 150%;
  }
  100% {
    left: 150%;
  }
}

@keyframes pulseText {
  0%,
  100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}

@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes floatUp3DBubble {
  0% {
    transform: translateY(0) scale(0.7) rotate(0deg);
    opacity: 0;
  }
  15% {
    opacity: 0.95;
  }
  85% {
    opacity: 0.95;
  }
  100% {
    transform: translateY(-280px) scale(1.25) rotate(360deg);
    opacity: 0;
  }
}

@keyframes scrollWheel {
  0% {
    opacity: 1;
    transform: translate(-50%, 0);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, 14px);
  }
}

@keyframes arrowPulse {
  0%,
  100% {
    transform: translateY(0);
    opacity: 0.5;
  }
  50% {
    transform: translateY(4px);
    opacity: 1;
  }
}

/* Responsive Adjustments */
@media (max-width: 960px) {
  #natcon-payment-create.natcon-luxury-app {
    .luxury-hero-section {
      min-height: 440px;
      padding: 40px 16px 60px 16px;

      .hero-glass-card {
        padding: 32px 20px;
      }
    }
    .luxury-stats-bar .stats-container {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}

@media (max-width: 600px) {
  #natcon-payment-create.natcon-luxury-app {
    .luxury-hero-section {
      .hero-glass-card {
        padding: 24px 16px;

        .hero-main-title {
          font-size: 28px;
        }
        .hero-subtitle {
          font-size: 14px;
        }
      }
    }
    .luxury-stats-bar .stats-container {
      grid-template-columns: 1fr;
    }
  }
}
</style>
